// PATH: src/components/modules/devtools/index.js

import React, { useState } from "react";
import DevIdePanel from "./panels/DevIdePanel";
import ChangesPanel from "./panels/ChangesPanel";
import ErrorLogPanel from "./panels/ErrorLogPanel";
import FullChangePanel from "./full_change/panels/FullChangePanel";
import PlannerPanel from "./planner/panels/PlannerPanel";
import LabPanel from "./lab/panels/LabPanel";
import DbExplorerPanel from "./panels/DbExplorerPanel";

export { DevIdePanel, ChangesPanel };

export default function DevToolsRoot() {
  const [tab, setTab] = useState("development");
  const [selectedProjectId, setSelectedProjectId] = useState("");

  return (
    <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <div
        style={{
          display: "flex",
          borderBottom: "1px solid #ddd",
          marginBottom: 8,
        }}
      >
        <div
          onClick={() => setTab("development")}
          style={{
            padding: "8px 16px",
            cursor: "pointer",
            borderBottom: tab === "development" ? "2px solid #1976d2" : "none",
          }}
        >
          Development
        </div>

        <div
          onClick={() => setTab("changes")}
          style={{
            padding: "8px 16px",
            cursor: "pointer",
            borderBottom: tab === "changes" ? "2px solid #1976d2" : "none",
          }}
        >
          Changes
        </div>

        <div
          onClick={() => setTab("fullChange")}
          style={{
            padding: "8px 16px",
            cursor: "pointer",
            borderBottom: tab === "fullChange" ? "2px solid #1976d2" : "none",
          }}
        >
          Full Change
        </div>

        <div
          onClick={() => setTab("planner")}
          style={{
            padding: "8px 16px",
            cursor: "pointer",
            borderBottom: tab === "planner" ? "2px solid #1976d2" : "none",
          }}
        >
          Planner
        </div>

        <div
          onClick={() => setTab("lab")}
          style={{
            padding: "8px 16px",
            cursor: "pointer",
            borderBottom: tab === "lab" ? "2px solid #1976d2" : "none",
          }}
        >
          Lab
        </div>

        <div
          onClick={() => setTab("db")}
          style={{
            padding: "8px 16px",
            cursor: "pointer",
            borderBottom: tab === "db" ? "2px solid #1976d2" : "none",
          }}
        >
          DB
        </div>

        <div
          onClick={() => setTab("errorLog")}
          style={{
            padding: "8px 16px",
            cursor: "pointer",
            borderBottom: tab === "errorLog" ? "2px solid #1976d2" : "none",
          }}
        >
          Error Log
        </div>
      </div>

      <div style={{ flex: 1, minHeight: 0 }}>
        {tab === "development" && (
          <DevIdePanel
            selectedProjectId={selectedProjectId}
            setSelectedProjectId={setSelectedProjectId}
          />
        )}
        {tab === "changes" && (
          <ChangesPanel
            selectedProjectId={selectedProjectId}
            onSelectedProjectChange={setSelectedProjectId}
          />
        )}
        {tab === "fullChange" && <FullChangePanel />}
        {tab === "planner" && <PlannerPanel />}
        {tab === "lab" && <LabPanel />}
        {tab === "db" && <DbExplorerPanel />}
        {tab === "errorLog" && <ErrorLogPanel />}
      </div>
    </div>
  );
}
